import { call, put } from 'redux-saga/effects'
import GetAddressesActions from '../Redux/GetAddressesRedux'
import LoginActions from '../Redux/LoginRedux'
export function* getAddresses(api, { params }) {
  try {
    const res = yield call(api, params)
    if (res === 'Unauthorized') {
      yield put(LoginActions.loginFailure())
      return
    }
    if (res.data) {
      yield put(GetAddressesActions.getAddressesSuccess(res.data))
    } else {
      yield put(GetAddressesActions.getAddressesFailure(res))
    }
  } catch (error) {
    yield put(GetAddressesActions.getAddressesFailure(error.message))
  }
}
